import FavouritesUnlocked from './FavouritesUnlocked';
import { connect } from 'react-redux';
import { setOnboardingStep } from '../../state/actions/currentOnboarding';
var mapDispatchToProps = {
  setOnboardingStep: setOnboardingStep
};
export default connect(null, mapDispatchToProps)(FavouritesUnlocked);